module.exports = __webpack_public_path__ + "static/fabio_palumbo-ed68ad462ded3ebf0ada89e44c21d7fc.png";